/* ========================================
   Artist Profile — Custom Sections Orchestrator
   Reads renderers registered on window.sectionRenderers
   ======================================== */

function renderCustomSections(sections) {
  const container = document.getElementById('custom-sections-container');
  if (!sections || sections.length === 0) return;

  const renderers = window.sectionRenderers || {};

  const html = sections.map(function(section) {
    const renderer = renderers[section.type];
    if (!renderer || !section.data) return '';
    const sectionHtml = renderer(section.data);
    if (!sectionHtml) return '';
    return '<div class="cs-section artist-reveal" data-section-id="' + escapeHtml(section.id) + '">' + sectionHtml + '</div>';
  }).join('');

  container.innerHTML = html;
}
